<template>
  <img src="../../styles/common/img/remove.png" alt="" class="close-icon-img" @click="clear" />
</template>

<script>
// 关闭icon
export default {
  name: 'FtCloseIcon',
  data() {
    return {};
  },
  methods: {
    clear() {
      this.$emit('clear', '');
    }
  }
};
</script>

<style lang="scss" scoped>
.close-icon-img {
  width: 0.75rem;
  height: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// ftCloseIcon.vue